// extracted by mini-css-extract-plugin
export default {"modal_success":"ModalSuccess_modal_success__CuXe7"};